module.exports = {"510115001":"柳城街道","510115002":"公平街道","510115003":"涌泉街道","510115004":"天府街道","510115005":"金马街道","510115006":"永宁街道","510115101":"和盛镇","510115105":"万春镇","510115106":"寿安镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510115.json
// module id = 2390
// module chunks = 0